import { Zap, ArrowUp } from "lucide-react";
import Logomark from "@/components/sections/Logomark";

export default function Footer() {
  const top = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="relative pt-12 pb-8 bg-white border-t border-[#eef0f5]">
      <div className="divider-glow mx-4 sm:mx-6" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 mt-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <Logomark size={36} />
            <div>
              <div className="font-display text-lg font-bold tracking-tight text-[#0a0e1a]">
                ARJ <span className="text-[#0066ff]">TEAM</span>
              </div>
              <div className="text-[10px] text-[#6b7280] font-mono-d uppercase tracking-[0.2em]">
                Premium Web & Mobile Studio
              </div>
            </div>
          </div>

          <div className="flex items-center gap-6 text-sm text-[#475569] font-medium">
            <a href="#services"  className="hover:text-[#0a0e1a] transition-colors" data-testid="footer-link-services">Services</a>
            <a href="#portfolio" className="hover:text-[#0a0e1a] transition-colors" data-testid="footer-link-portfolio">Showcase</a>
            <a href="#contact"   className="hover:text-[#0a0e1a] transition-colors" data-testid="footer-link-contact">Contact</a>
          </div>

          <button
            data-testid="footer-back-to-top"
            onClick={top}
            className="btn-ghost !py-2.5 !px-4 !text-sm"
          >
            Back to top <ArrowUp className="w-4 h-4" />
          </button>
        </div>

        <div className="mt-8 text-xs text-[#6b7280] text-center font-mono-d">
          © 2026 ARJ TEAM. All rights reserved.
          <span className="hidden sm:inline"> — <Zap className="inline w-3 h-3 text-[#10b981] -mt-0.5" /> Crafted with precision.</span>
        </div>
      </div>
    </footer>
  );
}
